/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingPlanBenefitsServer = void 0;
var http_1 = require("@wix/ambassador/runtime/http");
var PricingPlanBenefitsServer = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        BenefitManagement: function () {
            return function (headers) {
                var service = {
                    addResources: function (addResourcesRequest) {
                        return httpClient.invoke('POST', '/v2/plans/benefits/resources', addResourcesRequest, headers);
                    },
                    bulkDeleteResources: function (bulkDeleteResourcesRequest) {
                        return httpClient.invoke('DELETE', '/v2/plans/benefits/resources', bulkDeleteResourcesRequest, headers);
                    },
                    createPlanBenefits: function (createPlanBenefitsRequest) {
                        return httpClient.invoke('POST', '/v2/plans/{plan_id}/benefits', createPlanBenefitsRequest, headers);
                    },
                    deletePlanBenefits: function (deletePlanBenefitsRequest) {
                        return httpClient.invoke('POST', '/v2/plans/{plan_id}/delete-benefits', deletePlanBenefitsRequest, headers);
                    },
                    deleteResources: function (deleteResourcesRequest) {
                        return httpClient.invoke('POST', '/v2/delete-resources', deleteResourcesRequest, headers);
                    },
                    list: function (listRequest) { return httpClient.invoke('GET', '/v2/plans/benefits', listRequest, headers); },
                    update: function (updateBenefitsRequest) {
                        return httpClient.invoke('PUT', '/v2/plans/{plan_id}/benefits/overwrite', updateBenefitsRequest, headers);
                    },
                    updatePlanBenefits: function (updatePlanBenefitsRequest) {
                        return httpClient.invoke('PUT', '/v2/plans/{plan_id}/benefits', updatePlanBenefitsRequest, headers);
                    },
                };
                service.addResources.__http_method = 'POST';
                service.addResources.__http_url = '/v2/plans/benefits/resources';
                service.bulkDeleteResources.__http_method = 'DELETE';
                service.bulkDeleteResources.__http_url = '/v2/plans/benefits/resources';
                service.createPlanBenefits.__http_method = 'POST';
                service.createPlanBenefits.__http_url = '/v2/plans/{plan_id}/benefits';
                service.deletePlanBenefits.__http_method = 'POST';
                service.deletePlanBenefits.__http_url = '/v2/plans/{plan_id}/delete-benefits';
                service.deleteResources.__http_method = 'POST';
                service.deleteResources.__http_url = '/v2/delete-resources';
                service.list.__http_method = 'GET';
                service.list.__http_url = '/v2/plans/benefits';
                service.update.__http_method = 'PUT';
                service.update.__http_url = '/v2/plans/{plan_id}/benefits/overwrite';
                service.updatePlanBenefits.__http_method = 'PUT';
                service.updatePlanBenefits.__http_url = '/v2/plans/{plan_id}/benefits';
                return service;
            };
        },
        MemberBenefits: function () {
            return function (headers) {
                var service = {
                    adjustCredit: function (adjustCreditRequest) {
                        return httpClient.invoke('POST', '/v2/member-benefits/contacts/{contact_id}/adjustCredit', adjustCreditRequest, headers);
                    },
                    cancelRedemption: function (cancelRedemptionRequest) {
                        return httpClient.invoke('POST', '/v2/member-benefits/cancel-redemption', cancelRedemptionRequest, headers);
                    },
                    getBalance: function (getBalanceRequest) { return httpClient.invoke('GET', '/v2/member-benefits/balance', getBalanceRequest, headers); },
                    getEligibleOrders: function (getEligibleOrdersRequest) {
                        return httpClient.invoke('GET', '/v2/member-benefits/eligible-orders', getEligibleOrdersRequest, headers);
                    },
                    listTransactions: function (listTransactionsRequest) {
                        return httpClient.invoke('GET', '/v2/member-benefits/transactions', listTransactionsRequest, headers);
                    },
                    redeem: function (redeemRequest) { return httpClient.invoke('POST', '/v2/member-benefits/redeem', redeemRequest, headers); },
                };
                service.adjustCredit.__http_method = 'POST';
                service.adjustCredit.__http_url = '/v2/member-benefits/contacts/{contact_id}/adjustCredit';
                service.cancelRedemption.__http_method = 'POST';
                service.cancelRedemption.__http_url = '/v2/member-benefits/cancel-redemption';
                service.getBalance.__http_method = 'GET';
                service.getBalance.__http_url = '/v2/member-benefits/balance';
                service.getEligibleOrders.__http_method = 'GET';
                service.getEligibleOrders.__http_url = '/v2/member-benefits/eligible-orders';
                service.listTransactions.__http_method = 'GET';
                service.listTransactions.__http_url = '/v2/member-benefits/transactions';
                service.redeem.__http_method = 'POST';
                service.redeem.__http_url = '/v2/member-benefits/redeem';
                return service;
            };
        },
        MembershipsSPI: function () {
            return function (headers) {
                var service = {
                    chargeMembership: function (chargeMembershipRequest) {
                        return httpClient.invoke('POST', 'charge-membership', chargeMembershipRequest, headers);
                    },
                    getMembershipVoidability: function (getMembershipVoidabilityRequest) {
                        return httpClient.invoke('POST', 'get-voidability', getMembershipVoidabilityRequest, headers);
                    },
                    listEligibleMemberships: function (listEligibleMembershipsRequest) {
                        return httpClient.invoke('POST', 'list-eligible-memberships', listEligibleMembershipsRequest, headers);
                    },
                    voidMembershipCharge: function (voidMembershipChargeRequest) {
                        return httpClient.invoke('POST', 'void-membership-charge', voidMembershipChargeRequest, headers);
                    },
                };
                service.chargeMembership.__http_method = 'POST';
                service.chargeMembership.__http_url = 'charge-membership';
                service.getMembershipVoidability.__http_method = 'POST';
                service.getMembershipVoidability.__http_url = 'get-voidability';
                service.listEligibleMemberships.__http_method = 'POST';
                service.listEligibleMemberships.__http_url = 'list-eligible-memberships';
                service.voidMembershipCharge.__http_method = 'POST';
                service.voidMembershipCharge.__http_url = 'void-membership-charge';
                return service;
            };
        },
    };
};
exports.PricingPlanBenefitsServer = PricingPlanBenefitsServer;
exports.PricingPlanBenefitsServer.__transport = 'http';
__exportStar(require("./types"), exports);
//# sourceMappingURL=http.js.map